import React from "react";
import { getClassName } from "@utils";
import css from "./Skeleton.module.scss";

export enum SkeletonSize {
  S = "S",
  M = "M",
  L = "L",
}

export enum SkeletonVariant {
  Text = "Text",
  List = "List",
  Circle = "Circle",
}

export interface SkeletonProps {
  className?: string;
  rows?: number;
  size?: SkeletonSize;
  variant?: SkeletonVariant;
  width?: number;
}

const Skeleton: React.FC<SkeletonProps> = ({
  className,
  rows = 1,
  size = SkeletonSize.M,
  variant = SkeletonVariant.Text,
  width,
}) => {
  const attrs = {
    container: {
      className: getClassName(
        css.container,
        css[`container${size}`],
        css[`container${variant}`],
        className
      ),
      ...(width && variant !== SkeletonVariant.Circle ? { style: { width } } : {}),
    },
    circle: {
      className: css.circle,
    },
  };

  const renderTextRows = () =>
    Array.from({ length: rows }, (_, index) => {
      const attrs = {
        textRow: {
          className: getClassName(css.textRow),
        },
      };

      return <div {...attrs.textRow} key={index} />;
    });

  if (variant === SkeletonVariant.Circle) {
    return (
      <div {...attrs.container}>
        <div {...attrs.circle} />
      </div>
    );
  }

  return <div {...attrs.container}>{renderTextRows()}</div>;
};

export default Skeleton;
